import { createFormHookContexts } from "@tanstack/react-form";

import { m } from "@recobra/i18n/messages";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

const mRecord = m as Record<string, unknown>;

const callMessage = (key: string): string => {
  const fn = mRecord[key];
  if (typeof fn !== "function") return key;

  return String(fn.call(null));
};

export const getErrorMessage = (error: unknown): string | undefined => {
  if (typeof error === "string") return callMessage(error);

  if (error != null && typeof error === "object" && "message" in error) {
    const { message } = error;

    return typeof message === "string" ? callMessage(message) : "";
  }

  return undefined;
};
